<template>
<div class="chapter">
<div class="inner_page">
<p class="P_Normal__And__Centre_Alignment__And__Spacing_After__And__Spacing_Before__And__Line_Spacing"><span style=" font-family: 'Dante MT Std'; font-size: 2.50em;">The Honeywood Settlement</span></p>
<p class="P_Normal__And__Centre_Alignment__And__Spacing_After__And__Spacing_Before__And__Line_Spacing__OPENPAR_1_CLOSEPAR_"><span style=" font-family: 'Dante MT Std'; font-size: 1.75em;">by H.B. Creswell</span></p>
<p class="P_Normal__And__Centre_Alignment__And__Spacing_After__And__Spacing_Before__And__Line_Spacing__OPENPAR_2_CLOSEPAR_"><img alt="" src="image0.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section-0001.vue?6e6ab720